import { connect } from 'react-redux';

import {
  getFilteredSegments,
  getSelectedSegment,
  getTenantId,
} from '../../../reducers/analyticsApp';
import { selectSegment } from '../../../actions/segment';
import CompoundExecutionPane from '../../../components/compound/execution/Pane';

const mapStateToProps = (state, { params }) => {
  const selectedSegment = getSelectedSegment(state);
  const launchSelectedSegment = !!(
    !selectedSegment || String(selectedSegment.id) !== String(params.id)
  );

  return {
    item: getFilteredSegments(state).find((item) => String(item.id) === String(params.id)),
    tenantId: getTenantId(state),
    launchSelectedSegment,
    location: 'segments',
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  launchSegment: false,
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  if (!!stateProps.item && stateProps.launchSelectedSegment) {
    dispatchProps.dispatch(selectSegment(stateProps.item));
  }

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CompoundExecutionPane);
